/**
 * Store Dossiers Statuts
 */
export default {
    state: {
        statuts: [],
        statutMailAEnvoyerId: 1,
        statutMailEnvoyeId: 2,
        statutReponseRecuParCourrier: 3,
        statutReponseRecuParMail: 4,
        statutReponseRecuViaGed: 5,
        statutIncomplet: 6,
        statutComplet: 7,
        statutAImprimer: 8,
        statutASuperviser: 9,
        statutSupervise: 10,
        statutACorriger: 11,
        statutATeletransmettre: 13,
        statutTeletransmis: 14,
        statutEdite: 15,
    },

    mutations: {
        /**
         * Initialise le state statuts
         */
        setStatuts: function (state, statuts) {
            state.statuts = statuts
        }
    },

    getters: {
        /**
         * Liste d'options de statuts de dossiers
         */
        optionsStatuts: state => {
            return state.statuts.map(statut => {
                return {label: statut.nom, value: statut.id}
            })
        },

        statutsReponseRecu: state => {
            return [
                state.statutReponseRecuParCourrier,
                state.statutReponseRecuParMail,
                state.statutReponseRecuViaGed
            ]
        },

        statutsCollecteEnCours: state => {
            return [
                state.statutMailEnvoyeId,
                state.statutReponseRecuParCourrier,
                state.statutReponseRecuParMail,
                state.statutReponseRecuViaGed,
                state.statutEdite,
                state.statutIncomplet,
            ]
        },

        /**
         * Récupère le libelle du statut
         */
        getLibelleStatut: state => id => {
            let statut = state.statuts.find(statut => statut.id === parseInt(id))
            return statut ? statut.nom : ''
        },

        /**
         * Récupère l'ordre du statut
         */
        getOrdreStatut: state => id => {
            let statut = state.statuts.find(statut => statut.id === parseInt(id))
            return statut ? statut.ordre : ''
        }
    }
}
